import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import { Page } from '@src/interfaces/misc';
import Navigation from './Navigation';
import Settings from './Settings';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useLocale } from '../../i18n/LocaleContext';
interface HeaderProps {
  isAuthenticated: boolean;
}

const Header = ({ isAuthenticated }: HeaderProps) => {
  const { t } = useLocale();
  const auth = useContext(AuthContext);
  const pages: Page[] = [
    { title: t('navigation.home'), path: '/' },
    { title: t('navigation.stocks'), path: '/stocks/' },
    { title: t('navigation.evaluations'), path: '/signal-evaluations' },
    ...(auth?.user?.role === 'admin' ? [{ title: t('onboarding.title'), path: '/imports' }] : []),
    { title: t('navigation.logout'), path: '/logout' },
  ];
  const unauthenticatedPages: Page[] = [
    { title: t('navigation.home'), path: '/' },
    { title: t('navigation.login'), path: '/login' },
  ];

  return (
    <AppBar position="sticky">
      <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, lg: 4 } }}>
        <Toolbar disableGutters sx={{ gap: 2, minHeight: { xs: 56, sm: 72 } }}>
          <Navigation pages={isAuthenticated ? pages : unauthenticatedPages} />
          {isAuthenticated && <Settings />}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;
